import(/* webpackMode: "eager", webpackExports: ["default"] */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/layers/google.nodejs.yarn/yarn_modules/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/workspace/components/CTA.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/HeroText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/IdeaValidator.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/Process.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/SelectedWorks.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/ServicesMarquee.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/TechStack.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/Testimonials.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/TrustedBy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/LazySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn","Stagger","FadeInStaggerItem"] */ "/workspace/components/ui/motion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/components/ui/TiltCard.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/components/WhyUs.tsx");
